import { useRef, useEffect } from 'react'
import { ExternalLink } from 'lucide-react'

interface Props {
  html: string | null
}

export default function PreviewPanel({ html }: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    if (!iframeRef.current || !html) return
    const doc = iframeRef.current.contentDocument
    if (doc) {
      doc.open()
      doc.write(html)
      doc.close()
    }
  }, [html])

  const handleViewFullPage = () => {
    if (!html) return
    const blob = new Blob([html], { type: 'text/html' })
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }

  return (
    <div className="flex flex-1 flex-col bg-white">
      <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-4 py-2.5">
        <span className="text-xs font-medium text-gray-500">Preview</span>
        {html && (
          <button
            onClick={handleViewFullPage}
            className="flex items-center gap-1 text-xs text-blue-500 transition-colors hover:text-blue-600"
          >
            View Full Page
            <ExternalLink className="h-3 w-3" />
          </button>
        )}
      </div>
      <div className="flex-1 overflow-hidden">
        {html ? (
          <iframe
            ref={iframeRef}
            className="h-full w-full border-0 bg-white"
            sandbox="allow-scripts allow-same-origin"
            title="Demo preview"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-gray-400">
            Send a message to generate a preview
          </div>
        )}
      </div>
    </div>
  )
}
